export default __webpack_public_path__ + "static/media/product_fullwidth.d7cf2edc.jpg";